import staging from './staging';
import production from './production';
import development from './development';

export default {
  staging,
  development,
  production,
}[process.env.TARGET_ENV];
